import { ILiveCategoryLinkBulkFailedItemQuery } from '../interfaces/live-category-link-bulk-failed-item.query.interface';
import { ILiveCategoryLinkBulkQuery } from '../interfaces/live-category-link-bulk.query.interface';
import { LivecategoryLinkFailedItem } from './live-category-link-bulk-failed-item.model';
import { LiveCategoryLink } from './live-category-link.model';

// @dynamic
export class LiveCategoryLinkBulk {
    created: LiveCategoryLink[] = [];
    failed: ILiveCategoryLinkBulkFailedItemQuery[] = [];

    constructor(query: ILiveCategoryLinkBulkQuery) {
        this.created = query.created.map((item) => new LiveCategoryLink(item));
        this.failed = query.failed.map((item) => new LivecategoryLinkFailedItem(item));
    }
}
